module.exports = __webpack_public_path__ + "static/img/wangqihuodong.11cb1493.png";